import { DatePipe, registerLocaleData, TitleCasePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import es from "@angular/common/locales/es-AR";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthService } from "./services/admin/auth.service";
import { BffAuthInterceptor } from "./shared/data-access-bff/bff-csrf.interceptor";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { BeygooSecurityScriptComponent } from "./security-scripts/beygoo-script.component";
import { environment } from "src/environments/environment";

registerLocaleData(es);



@NgModule({

    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        BeygooSecurityScriptComponent,
        RecaptchaV3Module,
        BrowserAnimationsModule,
        AppRoutingModule],
    providers: [AuthService, DatePipe, TitleCasePipe,
        { provide: HTTP_INTERCEPTORS, useClass: BffAuthInterceptor, multi: true },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recpatchaKey },

        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
